<script>
export default {
  name: 'DynamicTable',
  props: {
    myFields: Array,
    generalData: Array,
    fieldsHide: Array,
    fieldsNames: Array
  },
  created () {
  },
  data () {
    return {
    }
  },
  methods: {
    edit (paramId) {
      for (let i = 0; i < this.generalData.length; i++) {
        if (paramId === this.generalData[i].id) {
          this.$emit('setCurrentModel', this.generalData[i])
        }
      }
    }
  }
}
</script>

<template>
  <div class="card-body bg-white p-3 mb-2">
    <table class="table table-striped" width="100%" cellspacing="0">
        <thead>
          <tr>
            <th v-for="field in myFields" v-bind:key="field.id">
              {{field}}
            <th/>
          </tr>
        </thead>
        <tbody>
        <tr v-for="myData in generalData" v-bind:key="myData.id">
            <td v-for="row in fieldsNames" v-bind:key="row.id">
                {{myData[row]}}
            </td>
            <td class="buttons">
              <a class="img-act-def">
                <img class="img-download-button" src="../assets/img/edit.svg" v-on:click="edit(myData.id)">
              </a>
            </td>
        </tr>
        </tbody>
    </table>
  </div>
</template>

<style>
  .img-download-button{width: 25px;}
  .img-download-button:hover{transition: .3s; transform: scale(1.2); cursor: pointer;}
  .buttons{width: 40px}
</style>
